import React from 'react';
import { Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const reviews = [
  {
    name: 'Shine Auto',
    rating: 5,
    text: 'I can\'t say enough good things about Nexera. I broke the screen on my iPhone 13 Pro Max and got water inside it while working. I run a business, so being without my phone wasn\'t an option. They got me in right away, fixed the water damage, replaced the screen, and had my phone running like brand new the same day. Super professional, honest, and fast. I\'m really happy with the repair - highly recommend!',
    date: 'November 2024'
  },
  {
    name: 'Moeen Samhan',
    rating: 5,
    text: 'My PS5 kept overheating and shutting off after a few minutes of playing. I brought it in and they did a full deep cleaning on it and now it runs perfectly. No more shutdowns and no overheating. Super quick service and fair pricing. Definitely glad I got it fixed here.',
    date: 'November 2024'
  },
  {
    name: 'Daniel Leal',
    rating: 5,
    text: 'I had a great experience with Nexera. The staff was friendly, professional, and really knew what they were doing. My phone screen was fixed quickly and the quality of the repair is excellent. The whole process was smooth from start to finish. I\'d definitely return and recommend them to anyone who needs reliable phone repairs.',
    date: 'October 2024'
  },
  {
    name: 'Aneesah Abdel Rahman',
    rating: 5,
    text: 'I had such a great experience at Nexera Phone and Tech repair! From the minute I walked in, everyone was super friendly and helpful. They figured out what was wrong with my phone right away and actually took the time to explain it, which I really appreciated. The repair was quick, the price was reasonable, and honestly my phone looks brand new. What I loved most was how positive, friendly and professional the whole vibe was. You can tell they actually care about their customers and take pride in what they do. If you\'re dealing with a cracked screen, a dead battery, or anything else, I definitely recommend going here. They made the whole experience easy and stress free.',
    date: 'October 2024'
  }
];

const ReviewsSection = () => {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Customer Reviews
          </h2>
          <div className="w-24 h-1 mx-auto mb-6" style={{ backgroundColor: '#00B3B3' }} />
          <p className="text-gray-600 text-lg">
            See what our satisfied customers have to say
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {reviews.map((review, index) => (
            <Card 
              key={index} 
              className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              <CardContent className="p-8">
                {/* Star Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star 
                      key={i} 
                      className="w-5 h-5 fill-current" 
                      style={{ color: '#FFB800' }}
                    />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-gray-700 leading-relaxed mb-6 italic">
                  "{review.text}"
                </p>

                {/* Reviewer Info */}
                <div className="border-t pt-4">
                  <p className="font-bold text-gray-900">{review.name}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Google Reviews Link */}
        <div className="text-center mt-12">
          <a 
            href="https://share.google/udiGsgTuj8s9oci0B"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
            style={{
              backgroundColor: '#00B3B3',
              color: 'white',
              textDecoration: 'none'
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#009999'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#00B3B3'}
          >
            <Star className="w-5 h-5 fill-current" />
            Read More Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
